import React, { useState, useEffect, useRef } from "react";
import { Room, RoomEvent, Track } from "livekit-client";

const TheoryWEBRTCMonitoring = () => {
  const [connected, setConnected] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [user, setUser] = useState(null);
  const roomRef = useRef(null);
  const localTracksRef = useRef([]);

  useEffect(() => {
    try {
      const persistedAuth = localStorage.getItem("persist:tagnet-auth");
      if (persistedAuth) {
        const parsed = JSON.parse(persistedAuth);
        const userData = parsed.user ? JSON.parse(parsed.user) : null;
        setUser(userData);
      }
    } catch (err) {
      console.error("Error parsing user data:", err);
    }
  }, []);

  console.log("user", user);

  useEffect(() => {
    const connectToRoom = async () => {
      try {
        const serverUrl = "wss://webrtc.tagindia.co.in";
        const token =
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJleUoxYzJWeWJtRnRaU0k2SW5KaGF6a3dNRE0wSWl3aWJtRnRaU0k2SWxKaGEyVnphQ0lzSW1KaGRHTm9ZMjlrWlNJNklsUkJSMEpCVkVOSU1qQXlOVk5GVUNJc0lrVnVjbTlzYkcxbGJuUk9ieUk2T1RBd016UXNJbkp2YkdVaU9pSjBjbUZwYm1WbEluMD0iLCJqdGkiOiJleUoxYzJWeWJtRnRaU0k2SW5KaGF6a3dNRE0wSWl3aWJtRnRaU0k2SWxKaGEyVnphQ0lzSW1KaGRHTm9ZMjlrWlNJNklsUkJSMEpCVkVOSU1qQXlOVk5GVUNJc0lrVnVjbTlzYkcxbGJuUk9ieUk2T1RBd016UXNJbkp2YkdVaU9pSjBjbUZwYm1WbEluMD0iLCJleHAiOjE3NTkyMzkxMDQsIm5iZiI6MTc1OTIyNDcwNCwiaWF0IjoxNzU5MjI0NzA0LCJpc3MiOiJBUEl3ZnFGcWF3VFY1aW8iLCJ2aWRlbyI6eyJyb29tSm9pbiI6dHJ1ZSwicm9vbUFkbWluIjpmYWxzZSwicm9vbSI6IlRBR0JBVENIMjAyNVNFUCJ9fQ.ZNfryf7AShqldoPzygmIwnj2qxPhVTfMkphwpVwq65k";

        const room = new Room({
          adaptiveStream: true,
          dynacast: true,
          videoCaptureDefaults: {
            resolution: {
              width: 1280,
              height: 720,
              frameRate: 30,
            },
          },
        });

        roomRef.current = room;

        // Connect to room
        await room.connect(serverUrl, token);
        console.log("Connected to room:", room.name);
        setConnected(true);

        // Publish local tracks
        const tracks = await room.localParticipant.setCameraEnabled(true);
        await room.localParticipant.setMicrophoneEnabled(true);

        // Update participants list
        const updateParticipants = () => {
          const allParticipants = [
            {
              id: room.localParticipant.identity,
              identity: room.localParticipant.identity || "You (Monitor)",
              isLocal: true,
              participant: room.localParticipant,
            },
            ...Array.from(room.remoteParticipants.values()).map((p) => ({
              id: p.identity,
              identity: p.identity,
              isLocal: false,
              participant: p,
            })),
          ];
          setParticipants(allParticipants);
        };

        // Event listeners
        room.on(RoomEvent.ParticipantConnected, (participant) => {
          console.log("Participant joined:", participant.identity);
          updateParticipants();
        });

        room.on(RoomEvent.ParticipantDisconnected, (participant) => {
          console.log("Participant left:", participant.identity);
          updateParticipants();
        });

        room.on(RoomEvent.TrackSubscribed, () => {
          updateParticipants();
        });

        room.on(RoomEvent.TrackUnsubscribed, () => {
          updateParticipants();
        });

        room.on(RoomEvent.Disconnected, () => {
          console.log("Disconnected from room");
          setConnected(false);
        });

        // Initial update
        updateParticipants();
      } catch (error) {
        console.error("Failed to connect:", error);
        setConnected(false);
      }
    };

    connectToRoom();

    // Cleanup
    return () => {
      if (roomRef.current) {
        roomRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div className="container-fluid py-4">
      <div className="text-center mb-4">
        <h4>Monitor Theory Exam for batch {user ? user.BatchId : "..."}</h4>
        {user && (
          <p className="text-muted">Monitoring as: {user.Name || "Monitor"}</p>
        )}
      </div>

      <div className="mb-3 d-flex align-items-center gap-3">
        <span
          className={`badge ${connected ? "bg-success" : "bg-warning"}`}
          style={{ fontSize: "14px", padding: "8px 12px" }}
        >
          {connected ? "Connected" : "Connecting..."}
        </span>
        <span
          className="badge bg-info"
          style={{ fontSize: "14px", padding: "8px 12px" }}
        >
          👥 {participants.length} Participants
        </span>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
          gap: "16px",
          marginTop: "20px",
        }}
      >
        {participants.map((p) => (
          <ParticipantVideo key={p.id} participant={p} />
        ))}
      </div>
    </div>
  );
};

const ParticipantVideo = ({ participant }) => {
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!participant || !participant.participant) return;

    const p = participant.participant;
    const videoElement = videoRef.current;
    const audioElement = audioRef.current;

    const attachTracks = () => {
      // Attach video track
      const videoTrack = Array.from(p.videoTrackPublications.values()).find(
        (pub) => pub.track && pub.kind === Track.Kind.Video
      );

      if (videoTrack?.track && videoElement) {
        videoTrack.track.attach(videoElement);
      }

      // Attach audio track (only for remote participants)
      if (!participant.isLocal) {
        const audioTrack = Array.from(p.audioTrackPublications.values()).find(
          (pub) => pub.track && pub.kind === Track.Kind.Audio
        );

        if (audioTrack?.track && audioElement) {
          audioTrack.track.attach(audioElement);
        }
      }
    };

    const detachTracks = () => {
      const videoTrack = Array.from(p.videoTrackPublications.values()).find(
        (pub) => pub.track && pub.kind === Track.Kind.Video
      );
      if (videoTrack?.track && videoElement) {
        videoTrack.track.detach(videoElement);
      }

      if (!participant.isLocal) {
        const audioTrack = Array.from(p.audioTrackPublications.values()).find(
          (pub) => pub.track && pub.kind === Track.Kind.Audio
        );
        if (audioTrack?.track && audioElement) {
          audioTrack.track.detach(audioElement);
        }
      }
    };

    attachTracks();

    // Listen for track events
    p.on(RoomEvent.TrackSubscribed, attachTracks);
    p.on(RoomEvent.TrackUnsubscribed, detachTracks);

    return () => {
      p.off(RoomEvent.TrackSubscribed, attachTracks);
      p.off(RoomEvent.TrackUnsubscribed, detachTracks);
      detachTracks();
    };
  }, [participant]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingBottom: "56.25%", // 16:9 aspect ratio
        background: "#1a1a1a",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      }}
    >
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted={participant.isLocal}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
      <audio ref={audioRef} autoPlay />

      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          background: "linear-gradient(to top, rgba(0,0,0,0.8), transparent)",
          color: "#fff",
          padding: "12px 16px",
          fontSize: "14px",
          fontWeight: "500",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span>{participant.identity}</span>
        {participant.isLocal && (
          <span
            style={{
              background: "rgba(34, 197, 94, 0.2)",
              color: "#22c55e",
              padding: "2px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            YOU
          </span>
        )}
      </div>
    </div>
  );
};

export default TheoryWEBRTCMonitoring;
